//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      dialog: false
    };
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    message: {
      type: String,
      required: true,
      default: "¿Esta seguro de realizar la acción?"
    }
  },
  methods: {
    onCancelar: function onCancelar() {
      this.$emit("onAceptar", false);
    },
    onAceptar: function onAceptar() {
      this.$emit("onAceptar", true);
    }
  }
};